module.exports = __webpack_public_path__ + "static/img/95.27f3bf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/95.png
// module id = F0O4
// module chunks = 0